import { Reducer } from 'redux';
import { ActionTypes, ActionPayload } from './actions';

interface State {
    content: string
    published: Date
    loading: boolean
    latestPostURL: string
    photos: string[]
}

export const initialState: State = {
    content: "",
    published: new Date(),
    loading: false,
    latestPostURL: "",
    photos: []
}

export const reducer: Reducer<State, ActionPayload> = (state = initialState, action): State => {
    switch (action.type) {

        case ActionTypes.CONTENT_UPDATED: {
            return { ...state, content: action.payload.content}
        }

        case ActionTypes.POST_SUBMIT_INIT: {
            return { ...state, loading: true }
        }

        case ActionTypes.POST_SUBMIT_SUCCESS: {
            return { ...initialState, latestPostURL: action.payload.newURL }
        }

        case ActionTypes.ADD_PHOTO_TO_POST: {
            return { ...state, photos: [...state.photos, action.payload.mediaURL]}
        }

        default: {
            return state;
        }
    }
}
